<template>
  <loading :active="allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <Dialog
    v-model:visible="showModal"
    class="w-60 bg-white shadow rounded-xl"
    :modal="true"
  >
    <template #header>
      <div class="w-full text-gray-900 font-semibold">{{lang['components']['Dialog']['ActivePlenItemDialog']['item_title']}}</div>
    </template>
    <div class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pb-8 rounded-bl-lg rounded-br-lg">
      <div class="lg:flex md:block sm:block pt-2 text-base text-gray-400">
        <RadioButton v-model="itemSelect" name="itemName" id="ingredient1" value="message" />
        <label for="ingredient1" class="ml-2">{{lang['components']['Dialog']['ActivePlenItemDialog']['item_change_plan']}}</label>
      </div>

      <div v-if="userStatus == 'y'" class="lg:flex md:block sm:block pt-2 text-base text-gray-400">
        <RadioButton v-model="itemSelect" name="itemName" id="ingredient2" value="stop" />
        <label for="ingredient2" class="ml-2">{{lang['components']['Dialog']['ActivePlenItemDialog']['item_stop_pay']}}</label>
      </div>
    </div>
    <template #footer>
      <div class="w-full text-right pt-4 border-t border-gray-400">
        <button
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400" @click="doActive">{{lang['components']['Dialog']['ActivePlenItemDialog']['check_button']}}</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import RadioButton from 'primevue/radiobutton';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "ActivePlenItemDialog",
  components: {
    Dialog,
    RadioButton,
    DataTable,
    Column,
    Loading
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    userStatus:{
      type: String,
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      itemSelect: null,
      allPageLoading: false,
    }
  },
  methods: {
    doActive(){
      console.log(this.itemSelect);

      if(this.itemSelect == 'message'){
        Swal.fire({
          icon: 'warning',
          title: this.lang['components']['Dialog']['PayRecordDialog']['axios']['swal_title'],
          text: this.lang['components']['Dialog']['PayRecordDialog']['axios']['swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.lang['components']['Dialog']['PayRecordDialog']['axios']['yes_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          window.open('https://m.me/1055506187980947','autoturn','width=1024,height=768');

          this.showModal = false
        })
      }

      if(this.itemSelect == 'stop'){
        Swal.fire({
          title: this.lang['components']['Dialog']['ActivePlenItemDialog']['doActive']['swal_title'],
          html: this.lang['components']['Dialog']['ActivePlenItemDialog']['doActive']['confirmed_html'],
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.lang['components']['Dialog']['ActivePlenItemDialog']['doActive']['confirmed_yes_button'],
          cancelButtonText: this.lang['components']['Dialog']['ActivePlenItemDialog']['doActive']['confirmed_no_button'],
        }).then((result) => {
          if (result.isConfirmed) {
            console.log('yes');

            this.allPageLoading = true
            this.showModal = false;

            // var todayForm = new Date();
            // var yearForm = todayForm.getFullYear();
            // var dateForm = String(todayForm.getDate()).padStart(2, '0');
            // var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            // var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            // todayForm = yearForm + monthForm + dateForm + timeForm;

            // console.log('1_'+todayForm);

            // this.$emit('closeModal', '1_'+todayForm);
            this.$emit('closeModal');

            axios
              .post('https://test.autoturn.net/inside/api/member_status_stop.php', Qs.stringify({
                s_code: this.$route.params.id,
              }))
              .then((caResponse) => {
                console.log('caResponse:');
                console.log(caResponse);

                this.allPageLoading = false

                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['Dialog']['ActivePlenItemDialog']['doActive']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['Dialog']['ActivePlenItemDialog']['doActive']['yes_button']
                }).then((result) => {
                  window.location.href = "https://dev-private.autoturn.net/"+this.$route.params.type+"/"+this.$route.params.id;
                });
              });
          }
        })
      }
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function(value) {
        this.$emit("update:show", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .p-datatable {
    tr button {
      opacity: 0;
    }

    tr {
      &:hover {
        button {
          opacity: 1;
        }
      }
    }
  }

  .p-datatable .p-datatable-thead > tr > th {
    background: transparent !important;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr > td {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr:hover {
    --tw-bg-opacity: 1;
    background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
  }
}
</style>
